const SET_GALLERY_CONTENT = 'SET_GALLERY_CONTENT';

export { SET_GALLERY_CONTENT };
